<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="700">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input" @submit.prevent="storeAsset">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4>Edit Device Configurations Scheduling</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col class="py-0" cols="12">
                            <v-text-field v-model="formData['label']" autofocus :rules="[vRules.required,vRules.maxLength(64)]"
                                          density="compact" label="Label"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0" cols="12" sm="6">
                            <v-switch v-model="formData['all_times_enabled']"
                                      color="primary"
                                      density="compact" label="All Times Enabled"
                                      @update:model-value="checkSwitches"/>
                            <v-switch v-model="formData['start_date_enabled']"
                                      color="primary"
                                      density="compact" label="Start Date Enabled"
                                      @update:model-value="checkSwitches"/>
                            <v-switch v-model="formData['end_date_enabled']"
                                      color="primary"
                                      density="compact" label="End Date Enabled"
                                      @update:model-value="checkSwitches"/>
                            <v-switch v-model="formData['weekdays_enabled']"
                                      color="primary"
                                      density="compact" label="weekdays Enabled"
                                      @update:model-value="checkSwitches"/>
                            <v-switch v-model="formData['months_enabled']"
                                      color="primary"
                                      density="compact" label="Months Enabled"
                                      @update:model-value="checkSwitches"/>
                            <v-switch v-model="formData['days_enabled']" color="primary" density="compact"
                                      label="Days Enabled"/>
                            <v-switch v-model="formData['hours_enabled']" color="primary" density="compact"
                                      label="Hours Enabled"/>
                            <v-switch v-model="formData['tod_enabled']"
                                      color="primary"
                                      density="compact" label="TOD Enabled"
                                      @update:model-value="checkSwitches"/>
                            <v-switch v-model="formData['interval_enabled']"
                                      color="primary"
                                      density="compact" label="Interval Enabled"
                                      @update:model-value="checkSwitches"/>
                        </v-col>
                        <v-col class="py-0" cols="12" sm="6">
                            <br><br>
                            <v-text-field v-model="formData['start_date']"
                                          :disabled="!formData['start_date_enabled']"
                                          density="compact" label="Start Date" type="date"/>

                            <v-text-field v-model="formData['end_date']"
                                          :disabled="!formData['end_date_enabled']"
                                          density="compact" label="End Date" type="date"/>

                            <v-select v-model="formData['weekdays']"
                                      :disabled="!formData['weekdays_enabled']" :items="weekdays"
                                      density="compact" item-title="title" item-value="value"
                                      label="Select weekdays" multiple/>

                            <v-select v-model="formData['months']"
                                      :disabled="!formData['months_enabled']" :items="months"
                                      density="compact" item-title="title" item-value="value"
                                      label="Select months" multiple/>

                            <v-select v-model="formData['days']"
                                      :disabled="!formData['days_enabled']" :items="days"
                                      density="compact" label="Select Days" multiple/>

                            <v-select v-model="formData['hours']"
                                      :disabled="!formData['hours_enabled']" :items="hours"
                                      density="compact" label="Select Hours" multiple/>

                            <v-text-field v-model="formData['tod_start']"
                                          :disabled="!formData['tod_enabled']"
                                          density="compact" label="Time of Day Start" type="time"/>

                            <v-text-field v-model="formData['tod_end']"
                                          :disabled="!formData['tod_enabled']"
                                          density="compact" label="Time of Day End" type="time"/>

                            <v-text-field v-model="formData['repeat_interval']"
                                          :disabled="!formData['interval_enabled']"
                                          density="compact" label="Repeat Schedule" type="number"/>

                            <v-select v-model="formData['repeat_interval_type']"
                                      :disabled="!formData['interval_enabled']"
                                      :items="[{value:0, title: 'Seconds'},{value:1, title: 'Minutes'},
                                      {value:2, title: 'Hours'},{value:3, title: 'Days'},{value:4, title: 'Months'},]"
                                      density="compact" item-title="title" item-value="value"
                                      label="Select Interval Time"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="px-4 d-flex justify-end">
                    <v-btn size="small" type="button"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const errors = ref([]);
const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    schedule: Object,
});
const dialogSwitch = ref(props.modelValue);
const formatTime = (time) => {
    let time_arr = time.split(':');
    if (time_arr.length > 1) {
        return `${time_arr[0]}:${time_arr[1]}`
    }
    return time_arr;
}
const formData = reactive({
    valid: false,
    label: props.schedule.label,
    company_id: props.schedule.company_id,
    all_times_enabled: !!props.schedule.all_times_enabled,
    start_date_enabled: !!props.schedule.start_date_enabled,
    end_date_enabled: !!props.schedule.end_date_enabled,
    weekdays_enabled: !!props.schedule.weekdays_enabled,
    months_enabled: !!props.schedule.months_enabled,
    days_enabled: !!props.schedule.days_enabled,
    hours_enabled: !!props.schedule.hours_enabled,
    tod_enabled: !!props.schedule.tod_enabled,
    interval_enabled: !!props.schedule.interval_enabled,
    repeat_interval_type: props.schedule.repeat_interval_type,
    repeat_interval: props.schedule.repeat_interval,
    start_date: props.schedule.start_date,
    end_date: props.schedule.end_date,
    months: props.schedule.months,
    days: props.schedule.days,
    hours: props.schedule.hours,
    weekdays: props.schedule.weekdays,
    tod_start: props.schedule.tod_start ? formatTime(props.schedule.tod_start) : null,
    tod_end: props.schedule.tod_end ? formatTime(props.schedule.tod_end) : null,
});
const emits = defineEmits(['update:modelValue', 'updateSchedule']);
const weekdays = ref([{value: 1, title: 'Monday'}, {value: 2, title: 'Tuesday'},
    {value: 3, title: 'Wednesday'}, {value: 4, title: 'Thursday'}, {value: 5, title: 'Friday'},
    {value: 6, title: 'Saturday'}, {value: 7, title: 'Sunday'}]);
const months = ref([{value: 1, title: 'January'}, {value: 2, title: 'February'},
    {value: 3, title: 'March'}, {value: 4, title: 'April'}, {value: 5, title: 'May'},
    {value: 6, title: 'June'}, {value: 7, title: 'July'}, {value: 8, title: 'August'}, {value: 9, title: 'September'},
    {value: 10, title: 'October'}, {value: 11, title: 'November'}, {value: 12, title: 'December'}]);
const days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
const hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
const toggleFields = {
    start_date_enabled: ['start_date'],
    end_date_enabled: ['end_date'],
    weekdays_enabled: ['weekdays'],
    months_enabled: ['months'],
    days_enabled: ['days'],
    hours_enabled: ['hours'],
    tod_enabled: ['tod_start', 'tod_end'],
    interval_enabled: ['repeat_interval', 'repeat_interval_type']
};
const checkSwitches = () => {
    // Calculate all_times_enabled dynamically
    formData['all_times_enabled'] = !Object.keys(toggleFields).some(key => formData[key]);
};

const storeAsset = () => {
    errors.value = [];
    // Clear fields based on enabled flags
    Object.entries(toggleFields).forEach(([key, fields]) => {
        if (!formData[key]) {
            fields.forEach(field => formData[field] = null);
        }
    });
    send('put', `monitoring/time-schedules/${props.schedule.id}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits('updateSchedule', response.data.data.schedule);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
